import store from 'store'

const el = '[data-content=MemberListOverlayCancerforum]'

export default function(Store){
    const DOM = document.querySelectorAll(el)
    if(DOM.length){
        DOM.forEach((MemberListOverlayDOM)=>{
            const groupId = MemberListOverlayDOM.dataset.groupId
            store.commit('main/set_page_overlay_content_data', { groupId })
        })
    }
}